import {
  Button,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import {
  fetchCheckAnswer,
  fetchFinishEducation,
} from "../../actions/education";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import EducationCustomModal from "./EducationCustomModal";
import { useTranslation } from "react-i18next"; // Dodano za prevođenje

const Questions = () => {
  const { educationItemsList } = useSelector((state) => state.educationReducer);
  const [activeQuestion, setActiveQuestion] = useState(0); // Aktivno pitanje
  const [selectedAnswer, setSelectedAnswer] = useState(null); // Selektovani odgovor
  const [isAnswerChecked, setIsAnswerChecked] = useState(false); // Da li je odgovor već proveren
  const [correctAnswersCount, setCorrectAnswersCount] = useState(0); // Brojač tačnih odgovora
  const [result, setResult] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [showModal, setShowModal] = useState(false);
  const [modalTitle, setModalTitle] = useState(0);
  const [modalMessageType, setModalMessageType] = useState("");

  const { t } = useTranslation(); // Dodano za prevođenje

  // Ako `educationItemsList` nije učitan, preusmeravamo korisnika
  useEffect(() => {
    if (!educationItemsList || !educationItemsList.questions) {
      navigate("/education-list");
    }
  }, [educationItemsList, navigate]);

  // Provera da li `educationItemsList` ima validne podatke
  if (!educationItemsList || !educationItemsList.questions) {
    return null;
  }

  const handleNext = () => {
    if (activeQuestion < educationItemsList?.questions?.length - 1) {
      setActiveQuestion(activeQuestion + 1); // Prelazimo na sledeće pitanje
      setSelectedAnswer(null); // Resetujemo odgovor pri prelasku na sledeće pitanje
      setIsAnswerChecked(false); // Resetujemo status da odgovor nije proveren
    } else {
      // Računamo rezultat
      const totalQuestions = educationItemsList?.questions?.length || 0;
      const successRate = (correctAnswersCount / totalQuestions) * 100;

      if (successRate >= 70) {
        const items = {
          educationAttemptId: educationItemsList.attemptId,
          status: "completed",
        };
        dispatch(fetchFinishEducation(items, navigate));

        setShowModal(true);
        setModalTitle(
          t("questions.modalSuccessTitle", {
            percentage: successRate.toFixed(2),
          })
        );
        setModalMessageType("success");
      } else {
        const items = {
          educationAttemptId: educationItemsList.attemptId,
          status: "failed",
        };
        dispatch(fetchFinishEducation(items, navigate));

        setShowModal(true);
        setModalTitle(
          t("questions.modalFailureTitle", {
            percentage: successRate.toFixed(2),
          })
        );
        setModalMessageType("error");
      }
    }
  };

  const handleAnswerClick = async (answerId) => {
    setSelectedAnswer(answerId);

    const questionId = educationItemsList?.questions[activeQuestion]?.id;

    try {
      const response = await dispatch(fetchCheckAnswer(questionId, answerId));

      setResult(response);
      setIsAnswerChecked(true);

      if (response.isCorrect) {
        setCorrectAnswersCount((prev) => prev + 1);
      }
    } catch (error) {
      console.error("Failed to check answer:", error);
    }
  };

  return (
    <div className="questions-main-container">
      <div className="questions-header-title">
        <h4>{t("questions.lgMasterClubTest")}</h4> {/* Prevođenje testa */}
      </div>
      <div className="questions-main-content">
        <div className="questions-main-title">
          <h4>{educationItemsList?.questions[activeQuestion]?.name}</h4>
        </div>

        <FormControl>
          {isAnswerChecked && <div className="mask-items-clickable"></div>}
          <RadioGroup value={selectedAnswer}>
            {educationItemsList?.questions[activeQuestion]?.answers?.map(
              (answer, index) => {
                let answerClass = "";

                if (isAnswerChecked) {
                  if (answer.id === result?.answerId) {
                    answerClass = "success"; // Tačan odgovor
                  } else if (
                    answer.id === selectedAnswer &&
                    !result?.isCorrect
                  ) {
                    answerClass = "error"; // Pogrešan odgovor
                  }
                }

                return (
                  <div
                    key={index}
                    className={`questions-answers ${answerClass}`}
                    onClick={() =>
                      !isAnswerChecked && handleAnswerClick(answer.id)
                    }
                  >
                    <span className="row-number-question">
                      {String.fromCharCode(65 + index)}
                    </span>
                    <div className="title-answer-main">{answer.text}</div>
                    <FormControlLabel
                      value={answer.id}
                      control={<Radio sx={{ display: "none" }} />} // Sakriven radio button
                      label=""
                    />
                    {answerClass === "success" && (
                      <span className="answer-info-icon success">
                        <CheckIcon />
                      </span>
                    )}
                    {answerClass === "error" && (
                      <span className="answer-info-icon error">
                        <CloseIcon />
                      </span>
                    )}
                  </div>
                );
              }
            )}
          </RadioGroup>
        </FormControl>
      </div>

      <div className="questions-footer-title">
        <Button
          className="next-question-answer"
          onClick={handleNext}
          disabled={!selectedAnswer || !isAnswerChecked}
        >
          {activeQuestion === educationItemsList?.questions?.length - 1
            ? t("questions.buttonFinishTest") // Prevođenje dugmeta za završetak testa
            : t("questions.buttonNextQuestionAnswer")}{" "}
          {/* Prevođenje dugmeta za sledeće pitanje */}
        </Button>
      </div>
      <EducationCustomModal
        showModal={showModal}
        messageType={modalMessageType}
        modalTitle={modalTitle}
      />
    </div>
  );
};

export default Questions;
